import React from 'react';
import { FrontOverlay, type FrontOverlayMode } from '../../../ips-react-front-fw/components/overlay';

type Props = {
  open: boolean;
  mode: FrontOverlayMode;
  loading: boolean;
  title: string;
  html: string;
  error: string | null;
  openPageHref: string;
  onClose: () => void;
};

export const SubscriptionOverlay: React.FC<Props> = ({
  open,
  mode,
  loading,
  title,
  html,
  error,
  openPageHref,
  onClose,
}) => {
  if (!open) {
    return null;
  }

  return (
    <FrontOverlay open={open} mode={mode} onClose={onClose} panelClassName="ips-front-subscription-overlay-panel">
      <div className="ips-front-subscription-overlay">
        <header className="ips-front-subscription-overlay__header">
          <h3>{title}</h3>
          <div className="ips-front-subscription-overlay__actions">
            <a href={openPageHref}>{'Vollseite öffnen'}</a>
            <button type="button" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>
        </header>

        <div className="ips-front-subscription-overlay__body">
          {loading && <div className="ips-front-subscription-overlay__loading" aria-hidden="true" />}
          {error && !loading && <p className="ips-front-subscription-overlay__error">{error}</p>}
          {!loading && !error && (
            <div
              className="ips-front-subscription-overlay__content"
              // HTML is rendered server-side from WooCommerce Subscriptions templates.
              dangerouslySetInnerHTML={{ __html: html }}
            />
          )}
        </div>
      </div>
    </FrontOverlay>
  );
};
